(function () {
  function isProductPage() {
    return document.body.classList.contains('template-product');
  }

  const SELECTORS = {
    picker: 'variant-swatch-king',
    atc: 'form[action^="/cart/add"] button[type="submit"], button.add-to-cart, button[name="add"]'
  };

  function movePickerAboveForm() {
    if (!isProductPage()) return false;

    const picker = document.querySelector(SELECTORS.picker);
    if (!picker) return false;

    const atcBtn = document.querySelector(SELECTORS.atc);
    if (!atcBtn) return false;

    const form = atcBtn.closest('form');
    if (!form) return false;

    // Al op juiste plek? Stop.
    if (picker.nextElementSibling === form) return true;

    form.parentNode.insertBefore(picker, form);
    return true;
  }

  function moveSizeChartToTalle() {
    if (!isProductPage()) return false;

    const sizeChartBlock = document.querySelector('div[id*="bf_size_charts_block"]') ||
                           document.querySelector('div.shopify-block.shopify-app-block');
    if (!sizeChartBlock) return false;

    const talleDiv = document.querySelector('div[option-name="Talle"]');
    if (!talleDiv) return false;

    const legend = talleDiv.querySelector('fieldset > legend') ||
                   talleDiv.querySelector('.swatch-label-container');
    if (!legend) return false;

    const sizeChartBtn = sizeChartBlock.querySelector('button.scr-open-size-chart') ||
                         sizeChartBlock.querySelector('div.best-fit-size-chart');
    if (!sizeChartBtn) return false;

    // Al op juiste plek? Stop.
    if (legend.contains(sizeChartBtn)) return true;

    legend.style.display = 'flex';
    legend.style.justifyContent = 'space-between';
    legend.style.alignItems = 'center';
    legend.style.width = '100%';

    legend.appendChild(sizeChartBtn);
    sizeChartBlock.style.display = 'none';

    return true;
  }

  function initWithRetry() {
    let pickerDone = false;
    let sizeChartDone = false;
    let attempts = 0;
    const maxAttempts = 20;

    const interval = setInterval(() => {
      attempts++;

      if (!pickerDone) {
        pickerDone = movePickerAboveForm();
      }

      if (!sizeChartDone) {
        sizeChartDone = moveSizeChartToTalle();
      }

      if ((pickerDone && sizeChartDone) || attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWithRetry);
  } else {
    initWithRetry();
  }

  document.addEventListener('shopify:section:load', initWithRetry);
  document.addEventListener('shopify:section:select', initWithRetry);
})();
(function () {
  function forceSwatchFont() {
    if (!document.body.classList.contains('template-product')) return;

    const labels = document.querySelectorAll(
      'variant-swatch-king span, variant-swatch-king label, variant-swatch-king legend, [class*="swatch-option-name"]'
    );

    labels.forEach(el => {
      el.style.setProperty('font-family', "'Nunito', sans-serif", 'important');
      el.style.setProperty('font-weight', '700', 'important');
      el.style.setProperty('letter-spacing', '0.05em', 'important');
      el.style.setProperty('text-transform', 'none', 'important');
    });
  }

  function init() {
    let attempts = 0;
    const interval = setInterval(() => {
      attempts++;
      forceSwatchFont();
      if (attempts >= 20) clearInterval(interval);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();